import { Spin, Table, Tabs } from 'antd';
import { filter, find } from 'lodash';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import TransferMoneyApi, {
  REASONS,
  TYPES,
} from '../../functions/api/booking/TransferMoneyApi';
import TableUtils from '../../functions/TableUtils';
import ButtonShowModalInfo from './ButtonShowModalInfo';
import ButtonShowModalStatus from './ButtonShowModalStatus';

class ListMoneyTransferRequest extends Component {
  constructor(props) {
    super(props);
    const userInfo = reactLocalStorage.getObject('user.info');
    this.state = {
      listTransferRequest: [],
      listTransferRequestWaitMe: [],
      userInfo,
    };
  }

  async componentDidMount() {
    const { userInfo } = this.state;

    const listAllTransferRequest = await TransferMoneyApi.getAll();

    const dataRequestConvert = listAllTransferRequest.map((r) => ({
      ...r,
      reason_name: find(REASONS, { reason_id: r.reason_id }).reason_name,
      type_name: find(TYPES, { type_id: r.type_id }).type_name,
    }));

    const listTransferRequestWaitMe = filter(dataRequestConvert, {
      user_in_charge: userInfo.user_acc_id.toString(),
    });

    this.setState({
      listTransferRequest: dataRequestConvert,
      listTransferRequestWaitMe: listTransferRequestWaitMe,
    });
  }

  render() {
    const { listTransferRequest, listTransferRequestWaitMe } = this.state;
    console.log(listTransferRequest);

    if (listTransferRequest.length === 0) {
      return <Spin />;
    }

    const columnRequest = [
      {
        title: 'STT',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
      },
      {
        title: 'Mã Booking',
        dataIndex: 'book_code',
        key: 'book_code',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('book_code'),
      },
      {
        title: ' Lý do chuyển',
        dataIndex: 'reason',
        key: 'reason',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('reason'),
      },
      {
        title: 'Loại yêu cầu',
        dataIndex: 'type_name',
        key: 'type_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listTransferRequest, 'type_name'),
      },
      {
        title: 'Mục đích',
        dataIndex: 'reason_name',
        key: 'reason_name',
        ...TableUtils.getColumnDropDownFilter(
          listTransferRequest,
          'reason_name'
        ),
      },
      {
        title: 'Người tạo',
        dataIndex: 'creator',
        key: 'creator',
        ...TableUtils.getColumnDropDownFilter(listTransferRequest, 'creator'),
      },

      {
        title: 'Xem',
        render: (row) => (
          <>
            {/* <Button
              onClick={() =>
                this.props.history.push(`transfer-requests/edit/${row.id}`)
              }
            >
              <i className="far fa-edit"></i>
            </Button> */}
            <ButtonShowModalStatus info={row} />
          </>
        ),
      },
    ];

    const columnRequestForMe = [
      {
        title: 'STT',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
      },
      {
        title: 'Mã Booking',
        dataIndex: 'book_code',
        key: 'book_code',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('book_code'),
      },
      {
        title: ' Lý do chuyển',
        dataIndex: 'reason_name',
        key: 'reason_name',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('reason_name'),
      },
      {
        title: 'Loại yêu cầu',
        dataIndex: 'type_name',
        key: 'type_name',
        fixed: 'left',

        render: this.renderTypeName,
        ...TableUtils.getColumnDropDownFilter(
          listTransferRequestWaitMe,
          'type_name'
        ),
      },
      {
        title: 'Mục đích',
        dataIndex: 'reason_id',
        key: 'reason_id',
        render: this.renderReasonName,
        ...TableUtils.getColumnDropDownFilter(
          listTransferRequestWaitMe,
          'reason_id'
        ),
      },
      {
        title: 'Người tạo',
        dataIndex: 'creator',
        key: 'creator',
        ...TableUtils.getColumnDropDownFilter(
          listTransferRequestWaitMe,
          'creator'
        ),
      },

      {
        title: 'Chỉnh sửa',
        render: (row) => (
          <>
            {/* <Button
              onClick={() =>
                this.props.history.push(`transfer-requests/edit/${row.id}`)
              }
            >
              <i className="far fa-edit"></i>
            </Button> */}
            <ButtonShowModalStatus info={row} />
            <ButtonShowModalInfo info={row} />
          </>
        ),
      },
    ];
    return (
      <>
        <h1>Danh sách các yêu cầu chuyển khoản</h1>

        <Tabs defaultActiveKey="1" centered>
          <Tabs.TabPane tab="Tất cả các yêu cầu" key="1">
            <Table
              rowKey="id"
              size="small"
              columns={columnRequest}
              dataSource={listTransferRequest}
              scroll={{ x: 'max-content' }}
              rowClassName={(record, index) => {
                if (record.status === 2) {
                  return 'text-warning';
                }
                if (record.status === 3) {
                  return 'text-success';
                }
                if (record.status === 4) {
                  return 'text-danger';
                }
              }}
            />
          </Tabs.TabPane>
          {listTransferRequestWaitMe.length > 0 && (
            <Tabs.TabPane tab="Yêu cầu chờ tôi duyệt" key="2">
              <Table
                rowKey="id"
                size="small"
                columns={columnRequestForMe}
                dataSource={listTransferRequestWaitMe}
                scroll={{ x: 'max-content' }}
                rowClassName={(record, index) => {
                  if (record.status === 2) {
                    return 'text-warning';
                  }
                  if (record.status === 3) {
                    return 'text-success';
                  }
                  if (record.status === 4) {
                    return 'text-danger';
                  }
                }}
              />
            </Tabs.TabPane>
          )}
        </Tabs>
      </>
    );
  }
}

export default withRouter(ListMoneyTransferRequest);
